
<template>
    <div class='content'>
        <div class="container">
            <div class="b_containerView">
                <div class="dataView">

                    <div class="left_a">
                        <img @click="changeHead" class="headImg" :src="avatar" alt="" />
                        <div class="username">{{ nameNew }}</div>
                        <div class="phoneVIew">
                            <span class="phoneVIewT1">手机号：{{ userinfoData.mobile }}</span>
                        </div>
                        <div class="upLoad" @click="$router.push('/home/upload')">
                            <img class="upLoadT1" src="../../assets/images/mine/a2.png" alt="" />
                            <span class="upLoadT2">上传资源/试题/班会</span>
                        </div>

                        <div :class="idx == 0 ? 'tabView' : 'tabView1'" style="margin-top: 28px;" @click="goTab(0)">
                            <div class="tabViewLeft">
                                <img class="tabViewLeftT1" src="../../assets/images/mine/a3.png" alt="" />
                                <span class="tabViewLeftT2">资源统计</span>
                            </div>
                            <img class="tabViewRight"
                                :src="idx == 0 ? require('../../assets/images/mine/a8.png') : require('../../assets/images/mine/a7.png')"
                                alt="" />
                        </div>
                        <div :class="idx == 1 ? 'tabView' : 'tabView1'" @click="goTab(1)">
                            <div class="tabViewLeft">
                                <img class="tabViewLeftT1" src="../../assets/images/mine/a4.png" alt="" />
                                <span class="tabViewLeftT2">我的收藏</span>
                            </div>
                            <img class="tabViewRight"
                                :src="idx == 1 ? require('../../assets/images/mine/a8.png') : require('../../assets/images/mine/a7.png')"
                                alt="" />
                        </div>
                        <div :class="idx == 2 ? 'tabView' : 'tabView1'" @click="goTab(2)">
                            <div class="tabViewLeft">
                                <img class="tabViewLeftT1" src="../../assets/images/mine/a5.png" alt="" />
                                <span class="tabViewLeftT2">我的资源/试题/班会</span>
                            </div>
                            <img class="tabViewRight"
                                :src="idx == 2 ? require('../../assets/images/mine/a8.png') : require('../../assets/images/mine/a7.png')"
                                alt="" />
                        </div>
                        <div :class="idx == 3 ? 'tabView' : 'tabView1'" @click="goTab(3)">
                            <div class="tabViewLeft">
                                <img class="tabViewLeftT1" src="../../assets/images/mine/a6.png" alt="" />
                                <span class="tabViewLeftT2">关于平台</span>
                            </div>
                            <img class="tabViewRight"
                                :src="idx == 3 ? require('../../assets/images/mine/a8.png') : require('../../assets/images/mine/a7.png')"
                                alt="" />
                        </div>
                    </div>

                    <!-- 资源统计 -->
                    <div class="left_b" v-if="idx == 0">
                        <div class="left_b_name">资源上传统计</div>
                        <div class="echartView">
                            <div class="echartViewBlock">
                                <div class="name">总数量：{{ tongjiInfo.total || 0 }}</div>
                                <div class="contentDiv" id="lbz"></div>
                            </div>
                            <div class="dataBlock">
                                <div class="dataBlockView" v-for="(v, index) in dataList" :key="index">
                                    <div class="aleft">
                                        <img class="imgB" :src="v.img" alt="" />
                                        <div class="t11">{{ v.name }}</div>
                                    </div>
                                    <div class="aleftLine"></div>
                                    <div class="bleft">
                                        <div class="bleftT1">总量</div>
                                        <div class="bleftT2">{{ v.all }}</div>
                                        <div class="bleftT3">今日更新：{{ v.updata }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left_b" v-if="idx == 1">
                        <collect></collect>
                    </div>
                    <div class="left_b" v-if="idx == 2">
                        <!-- :style="{ height: newH + 'px' }" -->
                        <resource></resource>
                    </div>
                    <div class="left_b" v-if="idx == 3" :style="{ height: newH + 'px' }">
                        <div class="htmlTT">
                            <div v-html="htmlF">

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <el-dialog :visible.sync="dialogFormVisible">
                <div class="dialogView">
                    <div class="dialogBlock">
                        <div class="t1">编辑基本信息</div>
                        <div class="touxiang">
                            <img class="txT1" :src="avatar" alt="" />
                            <div class="mb"></div>
                            <img class="xj" src="../../assets/images/mine/a10.png" alt="" />
                            <div class="uploaderView">
                                <el-upload class="avatar-uploader"
                                    action="http://tianyue.test.hbbright.cn/api/common/upload" :headers="{
                                        token: userinfoData.token
                                    }" :show-file-list="false" :on-success="handleAvatarSuccess">
                                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </div>
                        <div class="nameVIew">
                            <span class="nameT1">姓名</span>
                            <el-input placeholder="请输入姓名" v-model="nameNew">
                            </el-input>
                        </div>
                        <div class="btnView">
                            <div class="qx" @click="closeBtn">取消</div>
                            <div class="add" @click="add">保存</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    setProfileApi  //上传头像和昵称
} from "@/api/index";
var myChart;
import collect from "@/views/mine/collect"; //我的收藏
import resource from "@/views/mine/resource"; //我的收藏
export default {
    components: { collect, resource },
    data() {
        return {
            newH: '664',
            avatar: '',
            imageUrl: '',
            nameNew: '',
            // 编辑头像和昵称弹窗
            dialogFormVisible: false,
            idx: 0,
            userinfoData: '',
            showViewVideo: false,
            videoUrl: "",
            activeName: 'first',
            // 资源上传统计
            dataList: [],
            banner: [],
            newsList: [],
            newsBannerList: [],
            gonggaoList: [],
            // 统计信息
            tongjiInfo: {},
            // 资源列表
            sourceList: [],
            // 试题列表
            testTopicList: [],
            htmlF: ''
        }
    },
    watch: {
        showViewVideo(val) { val || this.$refs.video.pause(); },
    },
    mounted() {
        // this.getPageInfo();
        // this.$nextTick(() => {
        //     this.requirt();
        // })
        // 资源统计
        this.getTongji();
        this.getAboutPlatform();
        // this.getSource();
        // this.getTestTopic();
    },
    created() {
        this.nameNew = localStorage.getItem("username");
        this.avatar = localStorage.getItem("avatar");
        this.userinfoData = JSON.parse(localStorage.getItem("allNews")).userinfo;
        // console.warn(JSON.parse(localStorage.getItem("allNews")).userinfo)
    },
    methods: {
        // 个人中心
        // tianyue.com/api/index/aboutPlatform
        async getAboutPlatform() {
            try {
                const res = await this.$get('index/aboutPlatform')
                this.htmlF = res
                // console.warn(res, "res")
            } catch (error) { }
        },

        // 更改用户的头像和昵称
        async add() {
            if (this.imageUrl == '') {
                this.imageUrl = JSON.parse(localStorage.getItem("allNews")).userinfo.avatar;
            }
            if (this.nameNew == '') {
                this.$message({
                    message: '昵称不能为空',
                    type: 'error'
                });
                return
            }
            await setProfileApi({
                username: this.nameNew,
                avatar: this.imageUrl
            }).then((res) => {
                if (res.code == 1) {
                    localStorage.setItem("avatar", this.imageUrl);
                    localStorage.setItem("username", this.nameNew);
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.$router.go(0)
                }
                if (res.code == 0) {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err);
            })
            // console.warn(this.imageUrl, this.nameNew)
        },
        // 取消
        closeBtn() {
            this.dialogFormVisible = false;
            this.imageUrl = '';
            this.nameNew = JSON.parse(localStorage.getItem("allNews")).userinfo.username;
        },
        handleAvatarSuccess(res) {
            this.imageUrl = res.data.fullurl;
            if (res.code == 0) {
                this.$message.error(res.msg);
            }
            console.warn(res, "imageUrl")
        },
        // beforeAvatarUpload(file) {
        //     const isJPG = file.type === 'image/jpeg';
        //     const isLt2M = file.size / 1024 / 1024 < 2;

        //     if (!isJPG) {
        //         this.$message.error('上传头像图片只能是 JPG 格式!');
        //     }
        //     if (!isLt2M) {
        //         this.$message.error('上传头像图片大小不能超过 2MB!');
        //     }
        //     return isJPG && isLt2M;
        // },
        // 更换用户头像和昵称
        changeHead() {
            this.dialogFormVisible = true;
        },
        // 个人中心切换菜单
        goTab(e) {
            // console.warn("+++++++")
            if (e == 0) {
                this.getTongji();
                this.newH = '664'
            } else if (e == 1) {
                myChart.dispose();//销毁
                this.newH = '1224'
            } else if (e == 2) {
                myChart.dispose();//销毁
                this.newH = '1224'
            } else if (e == 3) {
                myChart.dispose();//销毁
                this.newH = '756'
            }
            // console.warn(e)
            this.idx = e;
        },
        /** 视频预览 */
        viewVideoHandle(url = "") {
            const isVideo = ['.rm', '.rmvb', '.wmv', '.asf', '.asx', '.mp4', '.3gp', '.mov', '.m4v', '.avi', '.dat', '.mkv', '.flv', '.vob',].some(item => ~url.indexOf(item));
            if (isVideo) {
                this.videoUrl = url;
                this.showViewVideo = true;
            } else window.open(url)
        },
        // 下载视频
        downVideo(item = {}) {
            if (!item.annex_file) return this.$message.info('无效的下载链接')
            if (item.downLoading) return;
            item.downLoading = true;
            fetch(item.annex_file).then(res => res.blob()).then(blob => {
                const a = document.createElement('a');
                document.body.appendChild(a)
                a.style.display = 'none'
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = item.annex_file;
                a.click();
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url);
                item.downLoading = false;
                const res = this.$get('school_source/download', {
                    id: item.id,
                })
                console.debug(res)
            }).catch(err => {
                item.downLoading = false;
                this.$message.error('下载fail，请稍后重试');
            })
        },
        /** 获取资源 */
        async getSource() {
            const res = await this.$get('school_source/recommend?type_data=1')
            this.sourceList = res.data.data || [];
        },
        /** 获取试题 */
        async getTestTopic() {
            const res = await this.$get('school_source/recommend?type_data=2')
            this.testTopicList = res.data || [];
        },
        // 统计数据
        async getTongji() {
            this.dataList = [];
            const res = await this.$get('person_center/tongji');
            this.tongjiInfo = res.data || {}
            this.dataList.push({
                name: '试题',
                all: this.tongjiInfo.question,
                updata: this.tongjiInfo.today_question,
                img: require("../../assets/images/home/b1.png"),
            });
            this.dataList.push({
                name: '图片',
                all: this.tongjiInfo.picture,
                updata: this.tongjiInfo.today_picture,
                img: require("../../assets/images/home/b2.png"),
            });
            this.dataList.push({
                name: '教案',
                all: this.tongjiInfo.teaching_plan,
                updata: this.tongjiInfo.today_teaching_plan,
                img: require("../../assets/images/home/b3.png"),
            });
            this.dataList.push({
                name: '素材',
                all: this.tongjiInfo.source_material,
                updata: this.tongjiInfo.today_source_material,
                img: require("../../assets/images/home/b4.png"),
            });
            this.dataList.push({
                name: '课件',
                all: this.tongjiInfo.course_ware,
                updata: this.tongjiInfo.today_course_ware,
                img: require("../../assets/images/home/b5.png"),
            });
            this.dataList.push({
                name: '班会',
                all: this.tongjiInfo.class_meet,
                updata: this.tongjiInfo.today_class_meet,
                img: require("../../assets/images/home/b6.png"),
            });
            this.dataList.push({
                name: '学案',
                all: this.tongjiInfo.study_case,
                updata: this.tongjiInfo.today_study_case,
                img: require("../../assets/images/home/b7.png"),
            });
            this.dataList.push({
                name: '家长会',
                all: this.tongjiInfo.parent_meet,
                updata: this.tongjiInfo.today_parent_meet,
                img: require("../../assets/images/home/b8.png"),
            });
            this.dataList.push({
                name: '视频',
                all: this.tongjiInfo.video,
                updata: this.tongjiInfo.today_video,
                img: require("../../assets/images/home/b9.png"),
            });
            this.dataList.push({
                name: '班主任管理',
                all: this.tongjiInfo.class_teacher,
                updata: this.tongjiInfo.today_class_teacher,
                img: require("../../assets/images/home/b10.png"),
            });
            this.$nextTick(() => {
                this.requirt();
            })
        },
        openBanner(item = {}) { window.open(item.carousel_url); },
        async getPageInfo() {
            const res = await this.$get('index/index');
            this.banner = res.data.carousel || [];
            this.newsList = res.data.news.newsList || [];
            this.newsBannerList = res.data.news.news_carousel || [];
            this.gonggaoList = res.data.new_announce || [];
        },
        requirt() {
            myChart = this.$echarts.init(document.getElementById('lbz'));
            var option;
            var data = this.dataList.map(item => {
                return {
                    name: item.name,
                    value: item.all,
                }
            })
            option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    icon: 'circle',
                    bottom: "bottom",
                    textStyle: { //图例文字的样式
                        color: '#333333',
                        fontSize: 16
                    }
                },
                series: [
                    {
                        name: '类别占比',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
                        data,
                        label: {
                            normal: {
                                show: true,
                                // formatter: '{b}:{d}%' //自定义显示格式(b:name, c:value, d:百分比)
                                formatter: (d) => {
                                    if (d.percent == undefined) {
                                        return d.name + '0%'
                                    } else {
                                        return d.name + d.percent + '%'
                                    }

                                }
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        },
        handleClick(tab, event) {
            console.log(tab, event);
        }
    },
}
</script>

<style lang='scss' scoped>
@import './index.scss';

.cur {
    cursor: pointer;
}
</style>